"use client";

import {
  getAutoOrderTypeByFrequenceId,
  isAutoOrderSubscribedByUser,
} from "@/app/ec/product/[basePath]/autoOrderSubscription";
import Alert from "@/components/design-system/alert";
import styles from "./autoOrderMessage.module.scss";

const getNextOrderDate = (subscriptionFutureDates: SubscriptionFutureDatesForProduct[] | null) => {
  if (isAutoOrderSubscribedByUser(subscriptionFutureDates)) {
    const subscription = subscriptionFutureDates && subscriptionFutureDates[0];
    if (!subscription) {
      return "";
    }
    if (subscription.IsSkipped === true) {
      return subscription.FutureOrderDates[1];
    } else {
      return subscription.NextOrderDate;
    }
  }
  return "";
};

const getFrequencyDescription = (subscriptionFutureDates: SubscriptionFutureDatesForProduct[] | null) => {
  if (isAutoOrderSubscribedByUser(subscriptionFutureDates)) {
    const subscription = subscriptionFutureDates && subscriptionFutureDates[0];
    return subscription ? getAutoOrderTypeByFrequenceId(subscription.FrequencyId).description : "";
  }
  return "";
};
const isAutoOrderPaused = (subscriptionFutureDates: SubscriptionFutureDatesForProduct[] | null) => {
  if (isAutoOrderSubscribedByUser(subscriptionFutureDates)) {
    return subscriptionFutureDates && subscriptionFutureDates[0].IsPaused;
  }
  return false;
};

function AutoOrderMessage({ data, frequency, nextOrderDate }: AutoOrderMessageProps) {
  const manageAction = { label: "Edit", href: "/account/orders/auto-order" };

  if (isAutoOrderPaused(data)) {
    return (
      <Alert
        className={styles.autoOrderStatusInfo}
        variant="neutral"
        size="small"
        title="This Auto Order is paused"
        action={manageAction}
      />
    );
  }

  const nextDate = getNextOrderDate(data) || nextOrderDate;
  const frequencyDescription = getFrequencyDescription(data) || frequency;

  return (
    <Alert
      className={styles.autoOrderStatusInfo}
      variant="neutral"
      size="small"
      title={frequencyDescription ? `Auto Order set for every ${frequencyDescription}` : "Auto Order is set up"}
      message={nextDate ? `Next order will be placed ${nextDate}` : undefined}
      action={manageAction}
    />
  );
}

export default AutoOrderMessage;

type AutoOrderMessageProps = {
  data: SubscriptionFutureDatesForProduct[] | null;
  frequency: string;
  nextOrderDate: string;
};
